// Student-specific routes
import { lazy } from 'react';

// Student pages
const StudentDashboard = lazy(() => import('@/pages/inside/student/Dashboard'));
const StudentProfile   = lazy(() => import('@/pages/inside/student/Profile'));
const StudentAttendance = lazy(() => import('@/pages/inside/student/Attendance'));
const StudentHomeworks  = lazy(() => import('@/pages/inside/student/Homeworks'));
const StudentTimetable  = lazy(() => import('@/pages/inside/student/Timetable'));
const StudentFees       = lazy(() => import('@/pages/inside/student/Fees'));

export const studentRoutes = [
    {
        path: '/student/dashboard',
        component: StudentDashboard,
        menuItem: { key: '/student/dashboard', label: 'Dashboard' },
    },
    {
        path: '/student/profile',
        component: StudentProfile,
        menuItem: { key: '/student/profile', label: 'My Profile' },
    },
    {
        path: '/student/attendance',
        component: StudentAttendance,
        menuItem: { key: '/student/attendance', label: 'Attendance' },
    },
    {
        path: '/student/homeworks',
        component: StudentHomeworks,
        menuItem: { key: '/student/homeworks', label: 'Homework' },
    },
    {
        path: '/student/timetable',
        component: StudentTimetable,
        menuItem: { key: '/student/timetable', label: 'Timetable' },
    },
    {
        path: '/student/fees',
        component: StudentFees,
        menuItem: { key: '/student/fees', label: 'Fees Details' },
    },
];
